/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-12, 09:15:53
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-04-11, 13:13:51
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import React from 'react';
import State from "components/layout/state";
import RemoveButton from "components/layout/removeButton";
import UpdateButton from "components/layout/updateButton";
import { Switch } from 'antd';

/**
 * Generate a random hash.
 * 
 * @export
 * @param {number} [len=10] 
 * @returns 
 */
export function hash(len = 10) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < len; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return `${text}${Math.floor(Math.random() * 9999) + 1}`;
}

/**
 * Prepare a standard action.
 * 
 * @export
 * @param {any} [types={}] 
 * @param {string} [url=''] 
 * @param {string} [action=''] 
 * @param {any} [data={}] 
 * @returns 
 */
export function createAction(types = {}, url = '', action = '', data = {}) {
  return {
    types: Object.values(types),
    promise: client => client[action](url, { data })
  };
}

/**
 * Change the object to query params url.
 * 
 * @export
 * @param {any} [object={}] 
 * @returns 
 */
export function httpBulidQuery(object = {}) {
  const filter = Object.entries(object)
    .map(([key, val]) => `${key}=${val}`)
    .join("&");
  return filter === "" ? "" : `&${filter}`;
}

/**
 * Change image to base64 string.
 * 
 * @export
 * @param {string} [img=""] 
 * @param {any} [callback=() => {}] 
 */
export function getBase64Image(img = "", callback = () => {}) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

/**
 * Change seconds on time.
 * 
 * @export
 * @param {number} [secs=0] 
 * @param {boolean} [addHour=false] 
 * @returns 
 */
export function seconds2Time(secs = 0, addHour = false) {
  secs = Math.round(secs);
  var hours = Math.floor(secs / (60 * 60));

  var divisor_for_minutes = secs % (60 * 60);
  var minutes = Math.floor(divisor_for_minutes / 60);

  var divisor_for_seconds = divisor_for_minutes % 60;
  var seconds = Math.ceil(divisor_for_seconds);

  hours = hours < 10 ? `0${hours}` : hours;
  seconds = seconds < 10 ? `0${seconds}` : seconds;
  minutes = minutes < 10 ? `0${minutes}` : minutes;

  return addHour? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
}

/**
 * Sort object by key.
 * 
 * @export
 * @param {any} [object={}] 
 * @param {string} [key=''] 
 * @returns 
 */
export function sortByKey(object = {}, key = '') {
  return object.sort((elementA, elementB) => {
    if(elementA[key] < elementB[key]) return -1;
    if(elementA[key] > elementB[key]) return 1;
    return 0;
  });
}

/**
 * Check if the specified element is a function.
 * 
 * @export
 * @param {string} [element=''] 
 * @returns 
 */
export function isFunction(element = "") {
  return typeof element === "function";
}

/**
 * Check if the specified element is an object.
 * 
 * @export
 * @param {string} [element=''] 
 * @returns 
 */
export function isObject(element = "") {
  return typeof element === "object";
}

/**
 * Get break points for mobile.
 * 
 * @export
 * @param {string} [$point=''] 
 * @param {integer} [change=0] 
 * @returns 
 */
export function breakpoints($point = '', change = 0) {
  change = parseInt(change);
  if (Number.isNaN(change)) change = 0;
  switch($point) {
    case 'blarge': return 1340 + change;
    case 'large': return 1280 + change;
    case 'xlarge': return 1100 + change;
    case 'small': return 992 + change;
    case 'xsmall': return 768 + change;
    case 'xmobile': return 648 + change;
    case 'mobile': return 480 + change;
    default: return 1280 + change;
  }
}

/**
 * What type action shoud be displayed.
 * 
 * @export
 * @param {any} [props={}] 
 * @returns 
 */
export function whatTypeOfActionShouldBeDisplayed(props = {}) {
  let action = 'list';
  action = props.location.pathname.includes('create')? 'create' : action;
  action = props.location.pathname.includes('update')? 'update' : action;
  action = props.location.pathname.includes('categories')? 'categories' : action;
  action = props.location.pathname.includes('titles')? 'titles' : action;

  return action;
}

/**
 * Show of state row.
 * 
 * @export
 * @param {boolean} [state=false] 
 * @returns 
 */
export function showStateOfRow(state = false) {
  return <State type={Boolean(state)} />;
}


/**
 * Show state of row as a checkbox.
 * 
 * @export
 * @param {boolean} [state=false] 
 * @param {function} [callback= () => {}]
 * @returns 
 */
export function showStateOfRowAsCheckbox(state = false, callback = () => {}) {
  return <Switch checked={state} onClick={callback} />
}

/**
 * Render actions for row list.
 * 
 * @export
 * @param {any} [actions={ update: null, remove: null }] 
 * @returns 
 */
export function renderActionsForRow(actions = { update: null, remove: null }) {
  return (
    <div>
      {actions.update? <UpdateButton callback={actions.update} /> : null}
      {actions.remove? <RemoveButton callback={actions.remove} /> : null}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/rcapp/helpers/utils.js